import waitForElementTransition from 'wait-for-element-transition';
import { scrollDetect } from 'utility';

// Only execute if element exists in the DOM (i.e. on child theme it won't)
if ( document.querySelector('.navbar__container') ) {
  const classToggle = (el, cls) => {
    el.classList[el.matches(`.${cls}`) ? 'remove' : 'add'](cls);
  };

  let depth = 0;

  document.addEventListener('click', (e) => {
    if (!e.target.matches('.navbar__link--children') && !e.target.matches('.navbar__link--children > a')) return false;

    if (!e.target.matches('.navbar__link--children > a span')) {

      let target = e.target.closest('.navbar__link--children');

      console.log(target.getAttribute('data-depth'));

      if (target.getAttribute('data-depth') == 1) {
        return;
      }

      e.preventDefault();
    }

    let target = e.target;


    if (!e.target.matches('.navbar__link--children')) {
      target = e.target.closest('.navbar__link--children');
    }

    depth++;
    if (depth) {
      target
        .closest('.navbar__container')
        .classList.add('navbar__container--active');
    }
    target.classList.add('navbar__link--active');
    document
      .querySelector('.navbar__links--bottom')
      .classList[depth > 0 ? 'add' : 'remove']('navbar__links--active');
    document.querySelector(
      '.navbar__links--bottom'
    ).style.transform = `translateX(-${depth * 100}%)`;
  });

  // document.addEventListener('click', (e) => {
  //   if (!e.target.matches('.lang-select__current')) return false;

  //   document.querySelector('.navbar__links--bottom').style.transform = 'unset';
  //   [...document.querySelectorAll('.navbar__link--active')].map((el) =>
  //     el.classList.remove('navbar__link--active')
  //   );
  //   depth = 0;

  //   depth++;
  //   if (depth) {
  //     e.target
  //       .closest('.navbar__container')
  //       .classList.add('navbar__container--active');
  //   }

  //   e.target.classList.add('lang-select__current--active');
  //   document
  //     .querySelector('.navbar__links--bottom')
  //     .classList[depth > 0 ? 'add' : 'remove']('navbar__links--active');
  //   document.querySelector(
  //     '.navbar__links--bottom'
  //   ).style.transform = `translateX(-${depth * 100}%)`;
  // });

  document.addEventListener('click', async (e) => {
    if (!e.target.matches('.navbar__back')) return false;
    depth--;
    const navbar = e.target
      .closest('.navbar__container')
      .querySelector(':scope .navbar__links--bottom');
    navbar.style.transform = `translateX(-${depth * 100}%)`;
    await waitForElementTransition(navbar);
    if (depth === 0) {
      e.target
        .closest('.navbar__container')
        .classList.remove('navbar__container--active');

      // if ( document.querySelector('.lang-select--mobile') ) {
      //   document.querySelector('.lang-select--mobile').querySelector('.lang-select__current')
      //     .classList.remove('lang-select__current--active');
      // }
    }

    if (document.querySelectorAll('.navbar__link--children.navbar__link--active').length > 0) {
      document
        .querySelectorAll('.navbar__link--children.navbar__link--active')
        [depth].classList.remove('navbar__link--active');
    }

    document
      .querySelector('.navbar__links--bottom')
      .classList[depth > 0 ? 'add' : 'remove']('navbar__links--active');
  });

  document.addEventListener('click', ({ target }) => {
    if (!target.matches('.hamburger')) return;
    classToggle(document.querySelector('.navbar'), 'navbar--active');
    document.querySelector('.navbar__links--bottom').style.transform = 'unset';
    [...document.querySelectorAll('.navbar__link--active')].map((el) =>
      el.classList.remove('navbar__link--active')
    );
    target
      .closest('.navbar__container')
      .classList.remove('navbar__container--active');
    depth = 0;
    document
      .querySelector('.navbar__links--bottom')
      .classList[depth > 0 ? 'add' : 'remove']('navbar__links--active');
  });

  const menuOverlay = (e) =>
    document.body.classList[
      e.target.matches('.navbar__bottom .navbar__link--children') ||
      e.target.closest('.navbar__bottom .navbar__link--children')
        ? 'add'
        : 'remove'
      ]('menu-is-open');

  window.responsive('desktop-min', () =>
    document.addEventListener('mouseover', menuOverlay)
  )
  window.responsive('tablet', () =>
    document.removeEventListener('mouseover', menuOverlay)
  );
  window.responsive('mobile', () =>
    document.removeEventListener('mouseover', menuOverlay)
  );

// Hide/Show on Scroll
  scrollDetect();
  window.addEventListener(
    'scrollDown',
    () => {
      const navbarHeight = document.querySelector('.navbar').getBoundingClientRect().height;
      if (window.scrollY > (navbarHeight * 2) ) {
        document.querySelector('.navbar').classList.remove('navbar--top');
        document.querySelector('.navbar').classList.add('navbar--hidden');
      }
    }
  );
  window.addEventListener('scrollUp', () =>
    document.querySelector('.navbar').classList.remove('navbar--hidden')
  );

// Transparent Navbar Toggle
  const config = {
    rootMargin: '0px',
    threshold: [0.1, 0.9]
  };

  const observer = new IntersectionObserver((entries, self) => {
    entries.forEach((entry) => {
      const header = document.querySelector('.navbar');

      if (entry.isIntersecting) {
        if (entry.intersectionRatio > 0.9) {
          if (entry.target.dataset.navTransparent !== undefined) {
            header.classList.add('navbar--transparent');
          } else {
            header.classList.remove('navbar--transparent');
          }
        } else {
          if (entry.target.getBoundingClientRect().top < header.getBoundingClientRect().height) {
            if (entry.target.dataset.navTransparent !== undefined) {
              header.classList.add('navbar--transparent');
            } else {
              header.classList.remove('navbar--transparent');
            }
          }
        }
      }
      const modifier = document.querySelector('#wpadminbar') ? document.querySelector('#wpadminbar').getBoundingClientRect().height : 0;
      if (window.scrollY < header.getBoundingClientRect().height + modifier) header.classList.remove('navbar--transparent');
    });

    const header = document.querySelector('.navbar');
    const modifier = document.querySelector('#wpadminbar') ? document.querySelector('#wpadminbar').getBoundingClientRect().height : 0;
    if (window.scrollY < header.getBoundingClientRect().height + modifier) header.classList.remove('navbar--transparent');
  }, config);

  [...document.querySelectorAll('main > *'), ...document.querySelectorAll('.page-links__content > *')].map(section => observer.observe(section));

  ['DOMContentLoaded', 'vue:loaded'].map(event => document.addEventListener(event, () => [...document.querySelectorAll('main > *'), ...document.querySelectorAll('.page-links__content > *')].map(section => observer.observe(section))));

  window.addEventListener('scrollToTop', () => document.querySelector('.navbar').classList[document.body.matches('.navbar-overlap') ? 'add' : 'remove']('navbar--transparent'));
  window.addEventListener('scrollToTop', () => document.querySelector('.navbar').classList.add('navbar--top'));

  const dropdownPositionFix = () => [...document.querySelectorAll('.navbar__link--top > .navbar__submenu')].map(el => window.innerWidth - el.getBoundingClientRect().right < 50  && el.style.setProperty('right', 0, 'important'));

  window.responsive('desktop', () => ['resize', 'DOMContentLoaded', 'vue:loaded'].map(event => window.addEventListener(event, dropdownPositionFix)));
  window.responsive('tablet', () => ['resize', 'DOMContentLoaded', 'vue:loaded'].map(event => window.removeEventListener(event, dropdownPositionFix)));
  window.responsive('mobile', () => ['resize', 'DOMContentLoaded', 'vue:loaded'].map(event => window.removeEventListener(event, dropdownPositionFix)));
}